import React from 'react';
import { weakKey } from '../../../../../../utilities/weakKey';
import { Text } from '../../../../../../components/textVariations';
import { Column } from '@codeparva/ui-components-library';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import { HorizontalAndVerticalCardConfig } from '../constants/horizontalAndVerticalCardConfig';
import { Icon } from '../../../../../../utilities/icomoon-css';

export const AmenitiesSection = ({
  amenity,
}: UnitAvailabilityTypes.TAmenityList) => {
  return (
    <div className="is-flex amenitiesSection" key={weakKey(amenity)}>
      <Column className="amenitiesList is-flex">
        <Icon
          name={amenity.amenity_icon}
          size={HorizontalAndVerticalCardConfig.amentityIconSize}
          title={amenity.amenity_icon}
          color="black"
        />
        <p className="amenityList">{amenity.amenity_text}</p>
      </Column>
    </div>
  );
};
export const getAmenitiesList = (
  data: UnitAvailabilityTypes.TData,
  WhatWeOfferConfig: any,
  viewCTAStatus: boolean
) => {
  if (
    data.amenitiesList &&
    data.amenitiesList.length <
      HorizontalAndVerticalCardConfig.maxAmenitiesCount
  ) {
    const amenitiesCount =
      HorizontalAndVerticalCardConfig.maxAmenitiesCount -
      data.amenitiesList.length;
    WhatWeOfferConfig.forEach((value: any, index: number) => {
      if (index < amenitiesCount) {
        data.amenitiesList.push({
          amenity_text: value.title,
          amenity_icon: value.icon_configs.icon_type.replace(/_/g, '-'),
        });
      }
    });

    return data.amenitiesList?.map(amenity => (
      <AmenitiesSection amenity={amenity} key={weakKey({ amenity })} />
    ));
  } else if (
    data.amenitiesList &&
    data.amenitiesList.length >
      HorizontalAndVerticalCardConfig.totalAmentiesCount
  ) {
    const amenities = viewCTAStatus
      ? data.amenitiesList
      : data.amenitiesList.slice(
          0,
          HorizontalAndVerticalCardConfig.maxAmenitiesCount
        );

    return (
      <>
        {amenities?.map(amenity => (
          <AmenitiesSection amenity={amenity} key={weakKey({ amenity })} />
        ))}
      </>
    );
  }
  return data.amenitiesList?.map(amenity => (
    <AmenitiesSection amenity={amenity} key={weakKey({ amenity })} />
  ));
};

export const GetAlertText = ({
  totalCount,
  isReservationOrMoveInEnabled,
}: UnitAvailabilityTypes.TTotalCountAndTFW) => {
  if (
    isReservationOrMoveInEnabled &&
    totalCount > 0 &&
    totalCount < HorizontalAndVerticalCardConfig.alertTextCount
  ) {
    return (
      <p className="has-text-highlight alertText subtitle1">
        {`Hurry! Only ${totalCount} Units Left`}
      </p>
    );
  } else if (
    isReservationOrMoveInEnabled &&
    totalCount > HorizontalAndVerticalCardConfig.alertTextCount
  ) {
    return (
      <p className="has-text-highlight alertText subtitle1">
        {HorizontalAndVerticalCardConfig.alertTextFewUnits}
      </p>
    );
  }
  return <Text className="alertTextNone"></Text>;
};
